import React from "react";
import { useLanguage } from "../../Translations/LenguageContext";

const PaymentInfo = () => {
    const {t} = useLanguage()
    
    return (
        <div className="payment_info_cont">
            <div className="payment_info_section">
                <p className="payment_info_cont_title">{t.website.how_payments_work.one_title}</p>

                <p className="payment_info_cont_parag">{t.website.how_payments_work.one_subtitle}</p>
            </div>

            <div className="payment_info_section">
                <p className="payment_info_cont_title">{t.website.how_payments_work.two_title}</p>
                <p className="payment_info_cont_parag">{t.website.how_payments_work.two_subtitle}</p>
            </div>

            <div className="payment_info_section">
                <p className="payment_info_cont_title">{t.website.how_payments_work.three_title}</p>
                <p className="payment_info_cont_parag">{t.website.how_payments_work.three_subtitle}</p>
            </div>

            <div className="payment_info_section">
                <p className="payment_info_cont_title">{t.website.how_payments_work.four_title}</p>
                <p className="payment_info_cont_parag">{t.website.how_payments_work.four_subtitle}</p>
            </div>

            <div className="payment_info_section">
                <p className="payment_info_cont_title">
                    {t.website.how_payments_work.five_title}
                </p>

                <p className="payment_info_cont_parag">
                    {t.website.how_payments_work.five_subtitle}
                </p>
            </div>
        </div>
    );
};

export default PaymentInfo;